import React, { useState } from 'react';

import TemplateSelectorDialog from '../agent_bar/message_template_dialog/message_template_dialog.js';

import userPlaceholder from "../../user-placeholder.png";

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
export default function Directory(props) {
  const [dialogIsOpen, setDialogIsOpen] = useState(false)
  const [activeContact, setActiveContact] = useState({})
  const [isSearching, setIsSearching] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const style = {
    left: props.isOpen ? "0" : "-110%",
  };

  const renderContact = (c) => {
    return (
      <li className="media my-1 contact p-2" key={c.numeroCliente} onClick={handleClickContact.bind(this, c)}>
        <img src={userPlaceholder} width="50" height="50" className="mr-3 rounded-circle" alt="..."/>
        <div className="media-body py-1">
          <h5 className="mt-0 mb-1">{c.nombreCompleto}</h5>
          <div>No. Cliente: {c.numeroCliente}</div>
          <small>Cel: {c.telefonoCelular} &mdash; Email: {c.email}</small>
        </div>
      </li>
    )
  }

  const renderEntry = (letter) => {
    return (
      <li className="media p-2" key={letter}>
        <h1>{letter}</h1>
      </li>
    )
  }

  const handleClickContact = (contact) => {
    setDialogIsOpen(true)
    setActiveContact(contact)
  }

  const handleSearch = (e) => {
    const query = e.target.value.toUpperCase()
    setSearchQuery(query)
    setIsSearching(query.length > 0)
  }

  let sortedContacts = [];
  if (props.directory !== null && Array.isArray(props.directory)) {
    sortedContacts = props.directory.sort((a, b) => a.nombreCompleto > b.nombreCompleto ? 1 : -1);
  } else {
    console.log('Falla al consultar la cartera de clientes.');
  }
  let entry = '';

  const toRender = sortedContacts.flatMap(contact => {
    if(isSearching) {
      try{
        if(contact.nombreCompleto.toUpperCase().includes(searchQuery) ||
          contact.telefonoCelular.includes(searchQuery) ||
          contact.email.toUpperCase().includes(searchQuery)) {
          return [renderContact(contact)]
        }
      }catch(error ){
        console.log(error) 
        console.log(contact)
      }
    } else  {
      const firstLetter = contact.nombreCompleto[0]
      if (firstLetter !== entry) {
        entry = firstLetter
        return [renderEntry(firstLetter), renderContact(contact)]
      } else {
        return [renderContact(contact)]
      }
    }
  })

  return (
    <div className="d-flex flex-column w-100 h-100 left-panel" id="directory" style={style}>
      <div className="row d-flex flex-row align-items-center p-2 m-0" style={{backgroundColor:"white", minHeight:"65px"}}>
          <i className="fas fa-arrow-left p-2 mx-3 my-1" style={{fontSize: "1.5rem", cursor: "pointer"}} onClick={props.close}></i>
          <div className="font-weight-bold">Cartera</div>
      </div>
      <div className="d-flex flex-column" style={{overflow:"auto"}}>
        <div className="px-3 py-2">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar contactos"
              onChange={handleSearch}
              style={{borderRadius: "20px"}}/>
          </div>
        </div>
        <ul className="list-unstyled bg-white">
          <li className="media p-2 action" onClick={props.openNewBroadcastList}>
            <button type="button" className="btn btn-success btn-lg mr-3 rounded-circle" style={{width: "64px", height: "64px"}}>
              <i className="fas fa-users"></i>
            </button>
            <div className="media-body align-self-center">
              <h5 className="mt-0 mb-1">Nueva difusión</h5>
            </div>
          </li>
          {toRender}
        </ul>
      </div>
      <TemplateSelectorDialog
        isOpen={dialogIsOpen}
        close={() => { setDialogIsOpen(false) }}
        templateList={props.templateList}
        currentAgent={props.currentAgent}
        defaultValue={activeContact}
        quickReplies={props.quickReplies}
      />
    </div>
  )
}
